module.exports = __webpack_public_path__ + "img/矢量智能对象2.5568f1c4.png";